import { useContext } from 'react';
import { InviteListingContext } from '../context/invite-listing-context';

export const useInviteListing = () => useContext(InviteListingContext);
